<template>
	<Transition name="modal">
		<div
			v-if="model"
			class="fixed z-50 inset-0 px-4 pt-4 bg-black/50 backdrop-blur-xs grid"
			@click.self="model = false"
		>
			<!-- content transition -->
			<div
				class="modal-content container p-0! max-h-full overflow-auto mx-auto mt-auto bg-white rounded-t-2xl"
			>
				<div class="p-10">
					<slot></slot>
				</div>
			</div>
		</div>
	</Transition>
</template>

<script setup lang="ts">
import type { Model } from '@/types/Modal'

const model = defineModel<Model>({ required: true })
</script>
